import moment from "moment";

import { api } from "@/APIRequests";
import { isAuthorized } from "@/redux/actions/auth";

/**
 * Gets the default allotted time for a schedule event based on provider type.
 *
 * @param {string} type - Event type (e.g., "away", "video_consultation")
 * @returns {number} Allotted time in minutes
 */
export const getAllottedTimeDefault = (type) => {
  if (isAuthorized("provider:behavioral") && type !== "away") {
    return 30;
  } else if (isAuthorized("provider:prescribe") && type !== "away") {
    return 15;
  } else {
    return 30;
  }
};

/**
 * Creates provider's schedules of one of the following types (AWAY / VIDEO_CONSULTATION).
 * Based on the type parameter, the appropriate API call is made.
 *
 * @param {string} type - type of new schedule (AWAY / VIDEO_CONSULTATION)
 * @param {Object} requestBody - The request body specific to the backend API
 * @param {string} [patientId] - The patient id with which the provider is creating schedule. Not needed for AWAY type
 * @param {string} tz - Timezone string
 */
export const createNewScheduledEvent = async (type, requestBody, patientId, tz) => {
  const data = {
    allotted_time: requestBody.allotted_time,
    event_type: type,
    local_date_time: requestBody.local_date_time,
    patient_id: patientId,
    seriesData: requestBody.seriesData,
    timezone: tz,
  };

  if (requestBody.providerId) {
    data.provider_id = requestBody.providerId;
  }

  if (requestBody.provider_id) {
    data.provider_id = requestBody.provider_id;
  }

  if (requestBody.label) {
    data.label = requestBody.label;
  }

  try {
    await api.schedule.post_schedule({ data });
  } catch (err) {
    console.log(err);
  }
};

/**
 * Gets existing schedule conflicts for a given date.
 * Filters schedule list to current date, removes deleted events,
 * and generates array of conflicting time slots.
 *
 * @param {Array} scheduleList - List of schedule events
 * @param {moment.Moment} selectedDate - The date to check conflicts for
 * @returns {Array<Array<string>>} Array of arrays containing time slots (HH:mm format)
 */
export const getExistingConflicts = (scheduleList, selectedDate) => {
  return scheduleList
    .filter(
      (event) =>
        moment.utc(event["timestamp"], "YYYY-MM-DD HH:mm").local().format("YYYY-MM-DD") ===
        selectedDate.format("YYYY-MM-DD"),
    )
    .filter((event) => !event.deleted)
    .map((event) => {
      let conflict = moment.utc(event["timestamp"], "YYYY-MM-DD HH:mm").local();
      const allottedTime = event["allotted_time"]
        ? event["allotted_time"]
        : getAllottedTimeDefault(event["type"]);
      let conflictEnd = moment
        .utc(event["timestamp"], "YYYY-MM-DD HH:mm")
        .local()
        .add(allottedTime, "minutes");
      const conflicts = [];

      while (conflict < conflictEnd) {
        conflicts.push(conflict.format("HH:mm"));
        conflict.add(15, "minutes");
      }

      return conflicts;
    });
};
